import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MouseTourComponent } from './mouse-tour.component';

@NgModule({ imports: [CommonModule],
  declarations: [MouseTourComponent],
  exports: [MouseTourComponent] })

export class MouseTourModule {}
